import { ResetPasswordForm } from '@/features/Auth';

const ResetPasswordPage = () => <ResetPasswordForm />;

export default ResetPasswordPage;